<template>
  <v-dialog v-model="dialog" max-width="440" persistent>
    <v-card>
      <v-card-title class="app-card-title">Atualizar vencimento</v-card-title>
      <v-card-text>
        <p class="mb-3">
          O DAE da competência
          <strong>{{ dae ? dae.competencia : "" }}</strong> está vencido.
          Informe a nova data de vencimento para gerar um boleto atualizado.
        </p>

        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dataFormatada"
              label="Nova data de vencimento *"
              placeholder="dd/mm/aaaa"
              readonly
              filled
              rounded
              dense
              prepend-inner-icon="event"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="data"
            :min="minDate"
            :max="maxDate"
            locale="pt-BR"
            @input="menu = false"
          ></v-date-picker>
        </v-menu>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fechar" :disabled="isLoading">Cancelar</v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="isLoading"
          :disabled="!data"
          @click="confirmar"
        >
          Atualizar e baixar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import GlobalStore from "@/store/modules/global";
import TaxaRegulacaoService from "@/services/taxaRegulacao.service";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import { VUE_APP_FINANCEIRO_API_URL } from "@/commons/config";

export default Vue.extend({
  props: {
    value: Boolean, // v-model do dialog
    dae: Object // a linha selecionada da tabela
  },
  data() {
    return {
      menu: false,
      data: null, // "YYYY-MM-DD" vindo do v-date-picker
      isLoading: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    minDate() {
      // tem que ser futura -> a partir de amanha
      return moment().add(1, "day").format("YYYY-MM-DD");
    },
    maxDate() {
      // no maximo 1 ano a frente
      return moment().add(1, "year").format("YYYY-MM-DD");
    },
    dataFormatada() {
      return this.data ? moment(this.data).format("DD/MM/YYYY") : "";
    }
  },
  methods: {
    fechar() {
      this.dialog = false;
      this.data = null;
    },
    abrirPdf(numeroDae) {
      if (numeroDae) {
        // vencido/reemitido: daeAtual resolve pro boleto vigente (o novo) a partir do numero antigo
        window.open(
          `${VUE_APP_FINANCEIRO_API_URL}/api/pdf/detran/daeAtual/${numeroDae}`,
          "_blank"
        );
      }
    },
    confirmar() {
      if (!this.data || !this.dae) return;

      const transportadora =
        TransportadoraAuthService.currentTransportadoraValue;
      const novaData = moment(this.data).format("DD/MM/YYYY");

      this.isLoading = true;
      TaxaRegulacaoService.reemitir(
        transportadora.id,
        transportadora.cnpj,
        this.dae.numeroDae,
        novaData
      ).subscribe(
        response => {
          this.isLoading = false;

          const mensagem = response && response.mensagem;
          if (mensagem === "gerado") {
            GlobalStore.setSnackBar({
              show: true,
              type: "warning",
              timeout: 5000,
              message: "Já existe um boleto válido para essa competência."
            });
          } else if (mensagem === "pago") {
            GlobalStore.setSnackBar({
              show: true,
              type: "warning",
              timeout: 5000,
              message: "Já existe um boleto pago para essa competência."
            });
          }

          this.abrirPdf(this.dae.numeroDae);
          this.$emit("reemitido");
          this.fechar();
        },
        error => {
          this.isLoading = false;
          const message =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.mensagem) ||
            "Não foi possível atualizar o vencimento. Tente novamente.";
          GlobalStore.setSnackBar({
            show: true,
            type: "error",
            timeout: 5000,
            message
          });
        }
      );
    }
  }
});
</script>
